import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type GroupHeaderComponentProps = {
    label: string | undefined;
};

const classNames = bemClassNames("menu-group-header-component");

/**
 * Komponenta pro nadpis skupiny v menu sekci Rychlý přístup.
 */
export const GroupHeaderComponent: FunctionComponent<GroupHeaderComponentProps> = ({ label }) => (
    <div className={classNames()} >
        {label}
    </div>
);
